import * as React from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import policyActions from '../../policy/policyActions';

import CustomerPolicyList from './CustomerPolicyList';
import CustomerApplicationList from './CustomerApplicationList';
import PolicyDetails from '../../policy/PolicyDetails';
import { ensureUserHasRoleAdminSite } from '../../auth/authComponents';
import { PolicyStatus, SecurityRoles } from '../../common/utils';

interface Props {
	className?: string;
	actions: any;
	customer: UserDetails;
	currentUser: UserDetails;
	customerPolicy: CustomerPolicy;
	questionnaireReport: any;
	policies: CustomerPolicy[];
	policyDocumentUrl: string;
	history: any;
	match: any;
}
interface State {
	loading: boolean;
}
class CustomerPolicyPage extends React.Component<Props, State> {
	state = {
		loading: true
	};

	componentDidMount() {
		this.props.actions.fetchCustomerPolicies(this.props.match.params.customerId, true)
			.then(() => this.setState({ loading: false }));
	}
	onRowClick = (e: any, row: any) => {
		e.stopPropagation();
		if (!window.location.href.includes('prospects')) {
			return this.props.history.push(`/admin/customers/${this.props.match.params.customerId}/policies/${row.id}`);
		} else {
			return this.props.history.push(`/admin/prospects/${this.props.match.params.customerId}/policies/${row.id}`);
		}
	}
	onDownloadClick = (e: any, row: any) => {
		this.props.actions.fetchCustomerPolicyDocumentUrl(this.props.match.params.customerId, row.id)
			.then(() => {
				window.open(this.props.policyDocumentUrl);
			});
	}
	isAdjudicator = (roles: string[] | undefined) => {
		if (!roles) {
			return false;
		}
		else {
			return roles.indexOf(SecurityRoles.Adjudicator) > -1 && roles.length === 1;
		}
	}

	render() {
		if (this.props.match.params.pageId) {
			return <PolicyDetails match={this.props.match} history={this.props.history} />;
		} else {
			const policies = this.props.policies.filter(x => x.statusId !== PolicyStatus.Inactive);
			const applications = this.props.policies.filter(x => x.statusId === PolicyStatus.Inactive);
			const applicationsAdjudicatorCanView = applications.filter(x => x.isSoftDeclined);

			return this.isAdjudicator(this.props.currentUser.role) ?
			(
				<div>
					{applicationsAdjudicatorCanView.length > 0 &&
							<div>
								<h2 className="form-fieldset-title">Applications</h2>
								<CustomerApplicationList
									className={this.props.className}
									applications={applicationsAdjudicatorCanView}
									onRowClick={this.onRowClick}
									loading={this.state.loading}
								/>
							</div>
						}
				</div>) :
			(
				<div>
					{policies.length > 0 &&
						<div className={applications.length > 0 ? 'mb-4' : ''}>
							<h2 className="form-fieldset-title">Policies</h2>
							<CustomerPolicyList
								className={this.props.className}
								policies={policies}
								onRowClick={this.onRowClick}
								onDownloadClick={this.onDownloadClick}
								loading={this.state.loading}
							/>
						</div>
					}
					{applications.length > 0 &&
						<div>
							<h2 className="form-fieldset-title">Applications</h2>
							<CustomerApplicationList
								className={this.props.className}
								applications={applications}
								onRowClick={this.onRowClick}
								loading={this.state.loading}
							/>
						</div>
					}
				</div>
			);
		}
	}
}
function mapStateToProps(state: any) {
	return {
		customer: state.user.user,
		currentUser: state.auth.currentUser,
		policies: state.policy.policies,
		customerPolicy: state.policy.customerPolicy,
		policyDocumentUrl: state.policy.tempPolicyDocumentUrl,
		questionnaireReport: state.policy.questionnaireReport,
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...policyActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
const connectedPage = connect(mapStateToProps, mapDispatchToProps)(CustomerPolicyPage);
const adminRoles = [SecurityRoles.Administrator, SecurityRoles.Agent, SecurityRoles.Adjudicator];
export default ensureUserHasRoleAdminSite(connectedPage as any, adminRoles);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/customers/CustomerPolicyPage.tsx